import axios from "axios";
import { API_URL } from "./apiUrl";

// export const API_URL = 'https://montenegromice.com/mice-api';

export const fetchMeetingRoomCapacities = () => {
  return axios
    .get(`${API_URL}/meeting-room-capacities`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteMeetingRoomCapacity = (meetingRoomCapacityId) => {
  return axios
    .delete(`${API_URL}/meeting-room-capacities/${meetingRoomCapacityId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri brisanju dokumenta: ${error.message}`);
    });
};

export const getMeetingRoomCapacity = async (id) => {
  try {
    const response = await axios.get(
      `${API_URL}/meeting-room-capacities/${id}`
    );
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri dobavljanju dokumenta: ${error.message}`);
  }
};

export const editMeetingRoomCapacity = async (id, meetingRoomCapacityData) => {
  try {
    const response = await axios.put(
      `${API_URL}/meeting-room-capacities/${id}`,
      meetingRoomCapacityData
    );
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri editovanju dokumenta: ${error.message}`);
  }
};

export const addMeetingRoomCapacity = (meetingRoomCapacityData) => {
  return axios
    .post(`${API_URL}/meeting-room-capacities`, meetingRoomCapacityData)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri dodavanju dokumenta: ${error.message}`);
    });
};
